import { useEffect, useState } from 'react';
import { useResizeObservedElement } from '../useResizeObservedElement';

/**
 * Returns the size information of the given element.
 * The size will also get observed and will trigger state updates when it changes
 */
export function useElementSize(element: Element | null): ElementSize | null {
  const [size, setSize] = useState<ElementSize | null>(getElementSize(element));

  useEffect(() => {
    setSize(getElementSize(element));
  }, [element]);

  useResizeObservedElement({
    element,
    callback: () => {
      setSize(getElementSize(element));
    }
  });

  return size;
}

function getElementSize(element: Element | null): ElementSize | null {
  if (!element) {
    return null;
  }

  return {
    clientHeight: element.clientHeight,
    clientWidth: element.clientWidth
  };
}

export type ElementSize = {
  clientWidth: number;
  clientHeight: number;
};
